import React, { useState, useEffect, useMemo } from "react";
import {
  getDocs,
  collection,
  query,
  doc,
  deleteDoc,
} from "firebase/firestore";
import { firestore } from "../pagini/Firebase";
import "./stiluri/AdministrareUtilizatori.css";
import { ClipLoader } from "react-spinners";
import CreateUserPopup from "../componente/administrare/CreateUserPopup";
import EditUserPopup from "../componente/administrare/EditUserPopup";

const AdministrareUtilizatori = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [utilizatori, setUtilizatori] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isCreateUserPopupOpen, setIsCreateUserPopupOpen] = useState(false);
  const [isEditUserPopupOpen, setIsEditUserPopupOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [showPermissionsModal, setShowPermissionsModal] = useState(null);

  const handleDeleteUser = async (userId) => {
    const isConfirmed = window.confirm("Ești sigur că vrei să ștergi acest utilizator?");
    if (!isConfirmed) return;

    try {
      await deleteDoc(doc(firestore, "Utilizatori", userId));
      setUtilizatori((prev) => prev.filter((user) => user.id !== userId));
      setMessage({ type: "success", text: "Utilizatorul a fost șters cu succes!" });
    } catch (error) {
      setMessage({ type: "error", text: "A apărut o eroare la ștergerea utilizatorului!" });
      console.error("Error deleting user: ", error);
    }
  };

  useEffect(() => {
    const fetchUtilizatori = async () => {
      setLoading(true);
      try {
        const usersRef = collection(firestore, "Utilizatori");
        const q = query(usersRef);
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const usersArray = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setUtilizatori(usersArray);
        } else {
          setUtilizatori([]);
        }
      } catch (error) {
        console.error("Error fetching users from Firestore: ", error);
        setMessage({
          type: "error",
          text: "A apărut o eroare la încărcarea utilizatorilor!",
        });
      }
      setLoading(false);
    };

    fetchUtilizatori();
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredUtilizatori = useMemo(() => {
    const term = searchTerm.toLowerCase();
    return utilizatori.filter((utilizator) =>
      (utilizator.nume && utilizator.nume.toLowerCase().includes(term)) ||
      (utilizator.email && utilizator.email.toLowerCase().includes(term))
    );
  }, [searchTerm, utilizatori]);

  const handleEdit = (utilizator) => {
    setSelectedUser(utilizator);
    setIsEditUserPopupOpen(true);
  };

  if (loading) {
    return <ClipLoader color="#36d7b7" loading={loading} size={50} />;
  }

  return (
    <div className="container-fluid-dashboard">
      <div className="titlu-container">
        <h2>Administrare Utilizatori</h2>
      </div>
      <p>Aici poți administra utilizatorii aplicației.</p>

      {message.text && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <div className="butoane-actiune">
        <div className="search-container">
          <input
            type="text"
            placeholder="Căutare utilizatori..."
            value={searchTerm}
            onChange={handleSearch}
          />
          <button>Căutare</button>
        </div>
        <button onClick={() => setIsCreateUserPopupOpen(true)}>
          Crează utilizator nou
        </button>
      </div>

      <table className="utilizatori-tabel">
        <thead>
          <tr>
            <th>Nume</th>
            <th>Email</th>
            <th>Rol</th>
            <th>Telefon</th>
            <th>Status</th>
            <th>Permisiuni</th>
            <th>Sectiuni</th>
            <th>Instituție</th>
            <th>Oraș</th>
            <th>Țară</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {filteredUtilizatori.length === 0 && searchTerm ? (
            <tr>
              <td colSpan="11">
                Nu au fost găsiți utilizatori pentru termenul căutat.
              </td>
            </tr>
          ) : (
            filteredUtilizatori.map((utilizator, index) => (
              <tr key={index}>
                <td>{utilizator.nume}</td>
                <td>{utilizator.email}</td>
                <td>{utilizator.role}</td>
                <td>{utilizator.telefon}</td>
                <td>{utilizator.status}</td>
                <td>
    <button className="btn btn-link btn-sm p-0" onClick={() => setShowPermissionsModal(index)}>
                    Vezi permisiuni
                  </button>                  {showPermissionsModal === index && (
                    <div className="modal-overlay">
                      <div className="modal-popup">
                        <h3>Permisiuni detaliate</h3>
                        {utilizator.permisiuni ? (
                          Object.entries(utilizator.permisiuni).map(([sectiune, nivele]) => {
                            const niveleActive = Object.entries(nivele)
                              .filter(([_, activ]) => activ)
                              .map(([nivel]) => nivel)
                              .join(", ");

                            if (!niveleActive) return null;

                            return (
                              <div key={sectiune}>
                                <strong>{sectiune.replaceAll("_", " ")}</strong>: {niveleActive}
                              </div>
                            );
                          })
                        ) : (
                          <p>Nicio permisiune setată</p>
                        )}
                        <button onClick={() => setShowPermissionsModal(null)}>Închide</button>
                      </div>
                    </div>
                  )}
                </td>
                <td>{utilizator.sectiuni?.join(", ")}</td>
                <td>{utilizator.institutie}</td>
                <td>{utilizator.oras}</td>
                <td>{utilizator.tara}</td>
                <td>
                  <button onClick={() => handleEdit(utilizator)}>Editează</button>
                  <button onClick={() => handleDeleteUser(utilizator.id)}>Șterge</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {isCreateUserPopupOpen && (
        <CreateUserPopup
          onClose={() => setIsCreateUserPopupOpen(false)}
        />
      )}

      {isEditUserPopupOpen && selectedUser && (
        <EditUserPopup
          selectedUser={selectedUser}
          onClose={() => setIsEditUserPopupOpen(false)}
          setSelectedUser={setSelectedUser}
          onSave={(updatedUser) => {
            setUtilizatori((prev) =>
              prev.map((u) => (u.cnp === updatedUser.cnp ? updatedUser : u))
            );
          }}
        />
      )}
    </div>
  );
};

export default AdministrareUtilizatori;